'use client'

import { useParams } from 'next/navigation'
import { Image as DatoImage } from 'react-datocms'
import { Button, Heading, RightTopArrow, cn } from '@desoutter/uikit'
import { ProductsCarouselCardFragment } from './ProductsCarouselCard.generated'
import { LocalizedLink } from '@/components/LocalizedLink'

type ProductsCarouselCardProps = {
	fragment: ProductsCarouselCardFragment
	isDark: boolean
	className?: string
}

export default function ProductsCarouselCard({
	fragment,
	isDark,
	className,
}: ProductsCarouselCardProps) {
	const { lang } = useParams()
	return (
		<LocalizedLink
			locale={lang}
			href={`/products/series/${fragment.subCategory?.slug}#${fragment.pimId}`}
			prefetch={false}
		>
			<div
				className={cn(
					'relative flex flex-col items-between h-full bg-gray-50 dark:bg-gray-800 rounded-2xl p-6',
					className,
				)}
			>
				<div className="absolute top-5 right-5 z-10">
					<Button
						size="xl"
						name="go to product"
						color={isDark ? 'tertiary' : 'secondary'}
						title="go to product"
						icon={RightTopArrow}
					/>
				</div>
				{fragment.image.responsiveImage && (
					<div className="relative w-[252px]">
						<DatoImage
							data={fragment.image.responsiveImage}
							usePlaceholder={false}
						/>
					</div>
				)}
				<div className="flex flex-col">
					<Heading as="h3" className="h5 dark:text-foreground">
						{fragment.name}
					</Heading>
					<p className="dark:text-foreground line-clamp-3">
						{fragment.shortDescription}
					</p>
				</div>
			</div>
		</LocalizedLink>
	)
}
